import MicroModal from 'micromodal';
import '../scss/style.scss';
import './vendor/radio-buttons.js';
import initProductZoom from './product-zoom.js';
import initProductCardSliders from './product-card-slider.js';
//import inView from 'in-view';
//var MicroModal = require('micromodal');



var isMobileSize,
	isTabletSize,
	isDesktopSize,
	isMobile,
	canMp4,
  currentScreenSize;



var APP = {

	init : function() {

		this.handlers.init();

    this.breakpoints();

    initProductZoom();
    initProductCardSliders();

    MicroModal.init();


    $(window).on('resize', function() {
      APP.breakpoints();
    })
    // inView('.product')
    // .on('enter', function(el){
    //   el.style.opacity = 1;
    // })
    // .on('exit', function(el){
    //     el.style.opacity = 0.2;
    // });


	},
	test : function() {

		function testMobile(){
			isMobile = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));
		}

		testMobile();

	},
  breakpoints : function() {

    var winWidth = $(window).width();

    if(winWidth < 700) {
     currentScreenSize = 'phone';
    } else if(winWidth >= 700 && winWidth < 1024) {
       currentScreenSize = 'tablet';
     } else if(winWidth >= 1024 && winWidth < 1250 ) {
       currentScreenSize = 'laptop';
     } else if(winWidth >= 1250 && winWidth < 1400 ) {
       currentScreenSize = 'desktop';
     } else if(winWidth >= 1400 && winWidth < 1800 ) {
       currentScreenSize = 'desktop-xl';
     } else {
       currentScreenSize = 'desktop-xxl';
     }

  },
	handlers : {

		//basic event handlers
		init : function()
		{

      $(document).on('click', '[data-toggle]', APP.handlers.toggler);
      $(document).on('click', '.accordion__toggle', APP.handlers.toggleAccordion);
      $(document).on('click', '.cart-toggle', APP.handlers.toggleCart);
      $(document).on('click', '.nav-toggle', APP.handlers.toggleNav);
      $(document).on('click', '.filter-toggle', APP.handlers.toggleFilter);
      $(document).on('click', '.search-toggle', APP.handlers.toggleSearch);
      $(document).on('click', '#overlay, .btn--close', APP.handlers.toggleOverlay);


      $(document).on('click', '[data-micromodal-trigger]', function(e) {

        e.preventDefault;
        var modal = $(this).data('micromodal-trigger');
        MicroModal.show(modal);

      });

      $(window).scroll(APP.scrolling);

      // Auto-hide messages
      setTimeout(function() {
        $('.woocommerce-message').slideUp('fast')
        $('.woocommerce-error').slideUp('fast')
        $('.woocommerce-info').slideUp('fast')
      }, 5000);

    $(document.body).on('updated_cart_totals', function() {
      setTimeout(function() {
        $('.woocommerce-message').slideUp('fast')
        $('.woocommerce-error').slideUp('fast')
        $('.woocommerce-info').slideUp('fast')
      }, 5000);
    });

    $(document).on('facetwp-loaded', function() {
      initProductCardSliders();
    });


		},
		toggler : function(e)
		{
			e.preventDefault();

			var target = $(this).data('toggle'),
				$_target = $(this).parent().find(target);
				target_is_open = $_target.hasClass('is-open');

				if(target_is_open) {
					$_target.removeClass('is-open');
				} else {
					$_target.addClass('is-open');
				}

    },
    toggleAccordion : function(e) {

			e.preventDefault();

			var $_toggle = $(this),
				$_question = $_toggle.parents('.accordion'),
				question_is_opened = $_question.hasClass('active');

			if(question_is_opened) {
				$_question.removeClass('active');
			} else {
				$_question.addClass('active');
			}

		},
    toggleCart : function(e) {

			e.preventDefault();

			var $_toggle = $(this),
				$_minicart = $('.mini-cart'),
				cart_is_opened = $_minicart.hasClass('is-open');

			if(cart_is_opened) {
				$_minicart.removeClass('is-open');
			} else {
				$_minicart.addClass('is-open');
			}

		},
    toggleNav : function(e) {

			e.preventDefault();

			var $_toggle = $(this),

				$_nav = $('#mainnav'),
				nav_is_opened = $_nav.hasClass('is-open');

			if(nav_is_opened) {
        $_toggle.removeClass('is-active');
				$_nav.removeClass('is-open');
			} else {
        $_toggle.addClass('is-active');
				$_nav.addClass('is-open');
			}

		},
    toggleFilter : function(e) {

			e.preventDefault();
			var $_toggle = $(this),
        $_body = $('body'),
				$_nav = $('#product-filter'),
				nav_is_opened = $_nav.hasClass('is-open');

      var $_overlay = $('<div id="overlay"></div>');

			if(nav_is_opened) {
        $_toggle.removeClass('is-active');
        $_body.removeClass('filter-is-open');
				$_nav.removeClass('is-open');
        APP.lock_scroll(false);
        $('#overlay').remove();
			} else {
        $
        $_toggle.addClass('is-active');
        $_body.addClass('filter-is-open');
				$_nav.addClass('is-open');
        APP.lock_scroll(true);
        $_overlay.appendTo($_body);
			}

		},

    toggleSearch : function(e) {

			e.preventDefault();

			var $_toggle = $(this),
        $_body = $('body'),
				$_search = $('#searchform'),
				search_is_opened = $_search.hasClass('is-open'),
				is_home = $_body.hasClass('home'),
				is_search = $_body.hasClass('search');


        if(!is_home && !is_search) {
    			if(search_is_opened) {
            $_toggle.removeClass('is-active');
            $_body.removeClass('search-is-open');
    				$_search.removeClass('is-open');
            APP.lock_scroll(false);
    			} else {
            $
            $_toggle.addClass('is-active');
            $_body.addClass('search-is-open');
    			  $_search.addClass('is-open').find('input[type=text]').focus();
            APP.lock_scroll(true);
    			}
        } else {
          $_search.find('input[type=text]').focus();
          if(is_search) {
            $('.page').find('input[name=s]').focus();
          }
        }

		},

    toggleOverlay : function(e) {

      e.preventDefault();

      var $_body = $('body');

      if($_body.hasClass('filter-is-open')) {
        $('.filter-toggle').first().trigger('click');
      }


    }

	},
	resizers : function()
	{
	},
  lock_scroll : function(state)
  {

    if(state == true) {

       $('body, html').width($('body').width())
              .height($('body').height())
              .css('overflow', 'hidden');

    } else {

      $('body, html').removeAttr('style');
      $('#content').removeAttr('style');

    }

  },
  scrolling : function()
  {
    var winHeight = $(window).height(),
				scrollPos = $(window).scrollTop() + winHeight,
        headerHeight = $('.site-header').outerHeight();

        if($('.checkout__fields').length > 0) {

          var $_field_cnt = $('.checkout__fields'),
              field_height = $_field_cnt.outerHeight(),
              field_bottom = $_field_cnt.position().top + field_height,
              field_top = $_field_cnt.offset().top,

              $_review_cnt = $('.checkout__review'),
              content_bottom = $_review_cnt.outerHeight(),

              bottom_line = winHeight - content_bottom;

            //  console.log('scrolltop: ' + $(window).scrollTop());
            //  console.log('top: ' + field_top);



              if($(window).scrollTop() > (field_top - headerHeight)) {
                if((scrollPos - bottom_line) >= (field_bottom)) {
                  $_review_cnt.removeClass('is-fixed').addClass('is-sticky');
                } else {
                  $_review_cnt.addClass('is-fixed').removeClass('is-sticky');
                }
              } else {
                $_review_cnt.removeClass('is-fixed');
              }



        }

				//reveal bottom border
				if($('#main').outerHeight() + 80 <= scrollPos) {
					$('#main').addClass('hide-bottom-border')
				} else {
					$('#main').removeClass('hide-bottom-border')
				}

				//compact logo
				if($(window).scrollTop() >= ($('.doc_header').outerHeight())) {
					$('.doc_header').addClass('is-compact');
				} else {
					$('.doc_header').removeClass('is-compact');
				}

				// Hide anchor scroll
				if(winHeight * 2 <= $(window).scrollTop()) {
					$('.anchor-scroll').hide();
				} else {
					$('.anchor-scroll').show();
				}

				//page navigation
				if($('.page__nav').length > 0) {
					if($(window).scrollTop() >= ($('.tab-content').position().top - 80)) {
						$('.page__nav').addClass('is-open');
					} else {
						$('.page__nav').removeClass('is-open');
					}
				}
  }
};


(function ($, window, document, undefined) {

  'use strict';

  $(function () {

  });

  APP.init();

})(jQuery, window, document);
